import React from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { AppState } from '../store/RootReducer';


import {
  OFFICE_SERVERS__ROOT,
  OFFICE_SERVERS__AUDIT_LOGS,
  FINALITY_LOGS__ROOT,
} from './Routes';

import Sidebar from './components/Sidebar';


import { ToastBoard } from '../components/toast/presentation/views';
import { removeToast } from '../components/toast/presentation/store/actions';
import { Toast } from '../components/toast/presentation/store/types';

import OfficeServersPage from './officeServers/presentation/views/OfficeServersPage';
import ServerAuditTrailPage from './officeServers/presentation/views/ServerAuditTrailPage';
import FinalityLogsPage from './finalityLogs/presentation/views/FinalityLogsPage';



const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
`;

const ActiveViewContainer = styled.div`
  position: relative;
  flex: 1;
  height: 100%auto;
  overflow: auto;
  background-color: #f6f7fa;
`;

const IndexRedirect = () => <Redirect to={OFFICE_SERVERS__ROOT} />;

interface StoreStateProps {
  toasts: Toast[];
}

interface StoreDispatchProps {
  closeToast: (toastId: string) => void;
}

interface OwnProps {

}

type Props = StoreStateProps & StoreDispatchProps & OwnProps;

function RootView(props: Props) {
  const { toasts, closeToast } = props;

  const history = useHistory();

  return (
    <Container>
      <Sidebar />

      <ActiveViewContainer>
        <ToastBoard toasts={toasts}
          closeHandler={closeToast}
        />

        <Switch>
          <Route exact path="/" component={IndexRedirect} />

          <Route exact path={OFFICE_SERVERS__ROOT} component={OfficeServersPage} />
          <Route exact path={`${OFFICE_SERVERS__AUDIT_LOGS}/:officeServer`} component={ServerAuditTrailPage} />

          <Route exact path={FINALITY_LOGS__ROOT} component={FinalityLogsPage} />
        </Switch>
      </ActiveViewContainer>
    </Container>
  );
}

const mapStateToProps = (state: AppState): StoreStateProps => ({
  toasts: state.toast.toasts
});

const mapDispatchToProps = (dispatch: (action: any) => void): StoreDispatchProps => ({
  closeToast(toastId: string) {
    dispatch(removeToast(toastId));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(RootView);
